/*@flow*/
import React from 'react';
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';
import useCachedQuery from 'lib/useCachedQuery';
import format from 'date-fns/format';
import compareAsc from 'date-fns/compareAsc';
import * as I from 'immutable';

const opts: any = { fetchPolicy: 'network-only' };
const OPTION = {
  awareOfUnicodeTokens: true,
};

const GET_EVENTS = (gql(`
  query getEvents($tenantId: ID!) {
    me {
      id
      company {
        id
        tenant(id: $tenantId) {
          id
          events {
            title
            category
            startsAt
            endsAt
          }
        }
      }
    }
  }
`): DocumentNode);

const Component = (props: { tenantId: ID }) => {
  const { data, loading, errors } = useCachedQuery(GET_EVENTS, {
    options: opts,
    variables: props,
  });
  if (loading) return null;
  if (errors) return <div>{errors}</div>;

  const keyPath = ['me', 'company', 'tenant', 'events'];
  const events = I.getIn(data, keyPath, []);
  if (events.length === 0) return null;

  // Somehow the array is frozen. (Maybe by the GraphQL client.)
  const unfrozenEvents = [...events];
  return (
    <table className="table table-small" style={{ marginTop: 10 }}>
      <thead>
        <tr>
          <th colSpan={3}>Events</th>
        </tr>
        <tr>
          <th>Title</th>
          <th>Category</th>
          <th>Starts At</th>
          <th>Ends At</th>
        </tr>
      </thead>
      <tbody>
        {unfrozenEvents
          .sort((a, b) => compareAsc(a.startsAt, b.startsAt))
          .map((v, i) => (
            <tr key={i}>
              <td>
                <a
                  href={`/page/${v.pageID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {v.title}
                </a>
              </td>
              <td>{v.category}</td>
              <td>{format(v.startsAt, 'hh:mm A, MM/DD/YYYY', OPTION)}</td>
              <td>{format(v.endsAt, 'hh:mm A, MM/DD/YYYY', OPTION)}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default Component;
